import * as React from "react";
import { AutoProfile } from "../types";
import classNames from "classnames";
import t from "../i18n";
import { dialogService } from "react-api-dialog";
import { MyAccountService } from "./myaccount-service";
import { messageDialog } from "../dialogs/MessageDialog";
import { formatDate } from "../utils";
import { confirmDialog } from "../dialogs/ConfirmDialog";
import { Frequency, RecurringProfileStatus } from "../types-enums";
import { humanizeDay } from "../services/date-time-service";
declare type AutoProfileBlockState = {
    isCancelled: boolean;
}
import { cardStyles } from "../_styles/receiptcard";
import { css } from "emotion";

export default class AutoProfileBlock extends React.Component<{ profile: AutoProfile }> {
    readonly state: AutoProfileBlockState = { isCancelled: false };
    cancelProfile = async (enabled: boolean) => {
        if (!enabled) return;
        const canCancel = await confirmDialog(t.myaccount("delete-auto-topup-confirm-message"), t.menu("auto_balance"), t.common("ok_button"), t.common("cancel_button"));
        if (canCancel.cancelled) {
            return;
        }
        dialogService.showPreloader();
        const response = await MyAccountService.cancelRecurringProfile(this.props.profile);
        await dialogService.hidePreloader();
        if (!response) return;
        if (response.responseCode !== 0) {
            messageDialog(t.autoTopup("auto_balance_cancel_fail"), t.menu("auto_balance"));
            return;
        }
        this.setState({ isCancelled: true });
        messageDialog(t.autoTopup("auto_balance_cancelled"), t.menu("auto_balance"));
    }
    formatMessage = (frequency: Frequency, topupDay: number, startDate: string | Date) => {
        startDate = new Date(startDate);
        const startDateFormated = formatDate(startDate);
        const freq = frequency === Frequency.Weekly ? t.autoTopup("week") : frequency === Frequency.BiWeekly ? t.autoTopup("frequency_15days") : t.autoTopup("month");
        const topupDayString = humanizeDay(topupDay, frequency);
        const message = t.autoTopup("schedule_short", {
            freq, topupDayString, startDateFormated
        });
        return message;
    }
    render() {
        const profile = this.props.profile;
        const buttonTitle = this.state.isCancelled ? t.common("cancelled") : t.common("cancel_button");
        const profileStatus = this.state.isCancelled ? "cancelled" :
            profile.status === RecurringProfileStatus.Active ||
                profile.status === RecurringProfileStatus.PendingApproval ? "active" : "rejected";
        const cls = profileStatus === "active" ? "default" : profileStatus === "rejected" ? "yellow" : "white";
        return (
            <div className="form-group col-sm-6">
                <div className={classNames(["receipt-card", css(cardStyles[cls])])}>
                    <div className="d-flex align-items-center justify-content-between">
                        <div>
                            <div>{profile.amount} {profile.sourceCurrencyCode} {/*profile.skuCategory*/}</div>
                            <div>
                                <i className="fa fa-user" />
                                <span style={{ marginLeft: 5 }}>+{profile.internationalCode} {profile.localMobileNumber}</span>
                            </div>
                            <div style={{fontWeight: "bold", fontStyle: "italic"}}>
                                {t.common(profileStatus)}
                            </div>
                        </div>
                        <div>
                            <a href="javascript: void(0)" onClick={e => this.cancelProfile(profileStatus === "active")}
                                className={classNames({ button: true, disabled: profileStatus !== "active" })}>{buttonTitle}</a>
                        </div>
                    </div>
                    <hr />
                    <div className="d-flex align-items-center justify-content-between">
                        <div className="font-italic font-weight-500">
                            {this.formatMessage(profile.frequency, profile.topupDay, profile.startDate)}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}